import styles from "../../assets/css/module/common/common.module.css";
import React, { useState, useContext, useEffect } from "react";
import Tippy from '@tippyjs/react';
import { useTranslation } from "react-i18next";
import { IsNotNull } from "../common/helpers";
import { LANGUAGES } from '../../language/language-list';
import { contextValues } from "../context/context-master";

const DropdownButton = (props) => {
  const { setLanguage } = useContext(contextValues);
  const [languageSelected, setLanguageSelected] = useState('en');
  const [optionsLanguage, setOptionsLanguage] = useState([])
  const { i18n, t } = useTranslation();

  function getOptionsLanguage() {
    let options = []
    LANGUAGES.map(x => {
      options.push({
        v: x.code,
        icon: x.icon,
        tooltip: x.label,
      })
    })
    setOptionsLanguage(options)
  }

  useEffect(() => {

    getOptionsLanguage()
  }, []);

  let def_value = LANGUAGES[0]
  let Icon = LANGUAGES[0].icon
  if (IsNotNull(props.label)) {
    def_value = LANGUAGES.find(y => y.code === props.label)
    Icon = def_value.icon
  }

  function onChangeLang(x) {
    localStorage.setItem('language', x)
    setLanguage(x)
    setLanguageSelected(x)
    i18n.changeLanguage(x);
  };

  const rs =
    <label className={`${styles['dropdown']} m-0`}>
      <div className={`${styles['dd-button']} `}> {<Icon />} </div>
      <input type="checkbox" className={`${styles['dd-input']} `} id="test" />
      <ul className={`${styles['dd-menu']} `}>
        {
          props.values.map((x, i) => {
            return <li key={i} onClick={e => onChangeLang(x.v)}>
                <x.icon />
              </li>
          })
        }
      </ul>
    </label>

  return rs
}


export {
  DropdownButton
}